import React from 'react';

import cx from 'classnames';

import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const NoTenders = ({ type, changeActiveTab }) => (
  <div className={cx('small-container', styles.container)}>
    <div className={styles.text}>
      You currently don’t have any {type} projects. Need help finding a PropTech
      solution? Create a project now.
    </div>
    <Button
      color="orange-gradient"
      className={styles.button}
      onClick={() => changeActiveTab(0)}>
      Create a Project
    </Button>
  </div>
);

export default NoTenders;
